
const authActions = {
  CLEAR_AUTH: 'CLEAR_AUTH',

  AUTH_REQUEST: 'AUTH_REQUEST',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_FAILURE: 'AUTH_FAILURE',

  USER_REQUEST: 'USER_REQUEST',
  USER_SUCCESS: 'USER_SUCCESS',
  USER_FAILURE: 'USER_FAILURE',
};

const jobActions = {

  GET_JOB_REQUEST: 'GET_JOB_REQUEST',
  GET_JOB_SUCCESS: 'GET_JOB_SUCCESS',
  GET_JOB_FAILURE: 'GET_JOB_FAILURE',

  PUT_JOB_REQUEST: 'PUT_JOB_REQUEST',
  PUT_JOB_SUCCESS: 'PUT_JOB_SUCCESS',
  PUT_JOB_FAILURE: 'PUT_JOB_FAILURE',

  POST_JOB_REQUEST: 'POST_JOB_REQUEST',
  POST_JOB_SUCCESS: 'POST_JOB_SUCCESS',
  POST_JOB_FAILURE: 'POST_JOB_FAILURE',

  DELETE_JOB_REQUEST: 'DELETE_JOB_REQUEST',
  DELETE_JOB_SUCCESS: 'DELETE_JOB_SUCCESS',
  DELETE_JOB_FAILURE: 'DELETE_JOB_FAILURE',

  PUT_DUPLICATE_JOB_REQUEST: 'PUT_DUPLICATE_JOB_REQUEST',
  PUT_DUPLICATE_JOB_SUCCESS: 'PUT_DUPLICATE_JOB_SUCCESS',
  PUT_DUPLICATE_JOB_FAILURE: 'PUT_DUPLICATE_JOB_FAILURE',

  GET_JOB_POSTINGS_PAGE_REQUEST: 'GET_JOB_POSTINGS_PAGE_REQUEST',
  GET_JOB_POSTINGS_PAGE_SUCCESS: 'GET_JOB_POSTINGS_PAGE_SUCCESS',
  GET_JOB_POSTINGS_PAGE_FAILURE: 'GET_JOB_POSTINGS_PAGE_FAILURE',

  GET_JOB_LEADS_PAGE_REQUEST: 'GET_JOB_LEADS_PAGE_REQUEST',
  GET_JOB_LEADS_PAGE_SUCCESS: 'GET_JOB_LEADS_PAGE_SUCCESS',
  GET_JOB_LEADS_PAGE_FAILURE: 'GET_JOB_LEADS_PAGE_FAILURE',

  GET_COMPANY_RECENTS_REQUEST: 'GET_COMPANY_RECENTS_REQUEST',
  GET_COMPANY_RECENTS_SUCCESS: 'GET_COMPANY_RECENTS_SUCCESS',
  GET_COMPANY_RECENTS_FAILURE: 'GET_COMPANY_RECENTS_FAILURE',

  GET_JOB_FILTERS_REQUEST: 'GET_JOB_FILTERS_REQUEST',
  GET_JOB_FILTERS_SUCCESS: 'GET_JOB_FILTERS_SUCCESS',
  GET_JOB_FILTERS_FAILURE: 'GET_JOB_FILTERS_FAILURE',

  FLUSH_POSTINGS_CACHE:  'FLUSH_POSTINGS_CACHE',
  TOGGLE_FILTER_OPTION: 'TOGGLE_FILTER_OPTION',
  UPDATE_FILTER_QUERY: 'UPDATE_FILTER_QUERY',
  FLUSH_LEADS_CACHE: 'FLUSH_LEADS_CACHE',
};

const openwebActions = {

  GET_OPENWEBS_REQUEST: 'GET_OPENWEBS_REQUEST',
  GET_OPENWEBS_SUCCESS: 'GET_OPENWEBS_SUCCESS',
  GET_OPENWEBS_FAILURE: 'GET_OPENWEBS_FAILURE',

  GET_OPENWEB_REQUEST: 'GET_OPENWEB_REQUEST',
  GET_OPENWEB_SUCCESS: 'GET_OPENWEB_SUCCESS',
  GET_OPENWEB_FAILURE: 'GET_OPENWEB_FAILURE',

  POST_OPENWEBS_REQUEST: "POST_OPENWEBS_REQUEST",
  POST_OPENWEBS_SUCCESS: "POST_OPENWEBS_SUCCESS",
  POST_OPENWEBS_FAILURE: "POST_OPENWEBS_FAILURE",

  GET_OPENWEB_JOBS_REQUEST: 'GET_OPENWEB_JOBS_REQUEST',
  GET_OPENWEB_JOBS_SUCCESS: 'GET_OPENWEB_JOBS_SUCCESS',
  GET_OPENWEB_JOBS_FAILURE: 'GET_OPENWEB_JOBS_FAILURE',

  GET_OPENWEB_JOB_REQUEST: 'GET_OPENWEB_JOB_REQUEST',
  GET_OPENWEB_JOB_SUCCESS: 'GET_OPENWEB_JOB_SUCCESS',
  GET_OPENWEB_JOB_FAILURE: 'GET_OPENWEB_JOB_FAILURE',

  PUT_OPENWEB_JOB_REQUEST: 'PUT_OPENWEB_JOB_REQUEST',
  PUT_OPENWEB_JOB_SUCCESS: 'PUT_OPENWEB_JOB_SUCCESS',
  PUT_OPENWEB_JOB_FAILURE: 'PUT_OPENWEB_JOB_FAILURE',

  PUT_OPENWEB_PROMOTE_REQUEST: 'PUT_OPENWEB_PROMOTE_REQUEST',
  PUT_OPENWEB_PROMOTE_SUCCESS: 'PUT_OPENWEB_PROMOTE_SUCCESS',
  PUT_OPENWEB_PROMOTE_FAILURE: 'PUT_OPENWEB_PROMOTE_FAILURE',

  PUT_OPENWEB_CLEAR_REQUEST: 'PUT_OPENWEB_CLEAR_REQUEST',
  PUT_OPENWEB_CLEAR_SUCCESS: 'PUT_OPENWEB_CLEAR_SUCCESS',
  PUT_OPENWEB_CLEAR_FAILURE: 'PUT_OPENWEB_CLEAR_FAILURE',

  FLUSH_OPENWEB_JOBS_CACHE:  'FLUSH_OPENWEB_JOBS_CACHE',
};

const companyActions = {

  POST_COMPANY_REQUEST: 'POST_COMPANY_REQUEST',
  POST_COMPANY_SUCCESS: 'POST_COMPANY_SUCCESS',
  POST_COMPANY_FAILURE: 'POST_COMPANY_FAILURE',

  PUT_COMPANY_REQUEST: 'PUT_COMPANY_REQUEST',
  PUT_COMPANY_SUCCESS: 'PUT_COMPANY_SUCCESS',
  PUT_COMPANY_FAILURE: 'PUT_COMPANY_FAILURE',

  GET_COMPANIES_REQUEST: 'GET_COMPANIES_REQUEST',
  GET_COMPANIES_SUCCESS: 'GET_COMPANIES_SUCCESS',
  GET_COMPANIES_FAILURE: 'GET_COMPANIES_FAILURE',

  GET_COMPANY_REQUEST: 'GET_COMPANY_REQUEST',
  GET_COMPANY_SUCCESS: 'GET_COMPANY_SUCCESS',
  GET_COMPANY_FAILURE: 'GET_COMPANY_FAILURE',

};

const agencyActions = {

  GET_AGENCIES_REQUEST: 'GET_AGENCIES_REQUEST',
  GET_AGENCIES_SUCCESS: 'GET_AGENCIES_SUCCESS',
  GET_AGENCIES_FAILURE: 'GET_AGENCIES_FAILURE',

  PUT_AGENCY_REQUEST: 'PUT_AGENCY_REQUEST',
  PUT_AGENCY_SUCCESS: 'PUT_AGENCY_SUCCESS',
  PUT_AGENCY_FAILURE: 'PUT_AGENCY_FAILURE',

  POST_AGENCY_REQUEST: 'POST_AGENCY_REQUEST',
  POST_AGENCY_SUCCESS: 'POST_AGENCY_SUCCESS',
  POST_AGENCY_FAILURE: 'POST_AGENCY_FAILURE',

  DELETE_AGENCY_REQUEST: 'DELETE_AGENCY_REQUEST',
  DELETE_AGENCY_SUCCESS: 'DELETE_AGENCY_SUCCESS',
  DELETE_AGENCY_FAILURE: 'DELETE_AGENCY_FAILURE',

};

const contactActions = {

  PUT_CONTACTS_REQUEST: 'PUT_CONTACTS_REQUEST',
  PUT_CONTACTS_SUCCESS: 'PUT_CONTACTS_SUCCESS',
  PUT_CONTACTS_FAILURE: 'PUT_CONTACTS_FAILURE',

};

const titleActions = {

  GET_TITLES_REQUEST: 'GET_TITLES_REQUEST',
  GET_TITLES_SUCCESS: 'GET_TITLES_SUCCESS',
  GET_TITLES_FAILURE: 'GET_TITLES_FAILURE',

  DELETE_TITLE_REQUEST: 'DELETE_TITLE_REQUEST',
  DELETE_TITLE_SUCCESS: 'DELETE_TITLE_SUCCESS',
  DELETE_TITLE_FAILURE: 'DELETE_TITLE_FAILURE',

  POST_TITLE_REQUEST: 'POST_TITLE_REQUEST',
  POST_TITLE_SUCCESS: 'POST_TITLE_SUCCESS',
  POST_TITLE_FAILURE: 'POST_TITLE_FAILURE',

  PUT_TITLE_REQUEST: 'PUT_TITLE_REQUEST',
  PUT_TITLE_SUCCESS: 'PUT_TITLE_SUCCESS',
  PUT_TITLE_FAILURE: 'PUT_TITLE_FAILURE',

};

const dashboardActions = {

  POST_REPORT_LEADS_REQUEST: 'POST_REPORT_LEADS_REQUEST',
  POST_REPORT_LEADS_SUCCESS: 'POST_REPORT_LEADS_SUCCESS',
  POST_REPORT_LEADS_FAILURE: 'POST_REPORT_LEADS_FAILURE',

  POST_REPORT_AGENCIES_REQUEST: 'POST_REPORT_AGENCIES_REQUEST',
  POST_REPORT_AGENCIES_SUCCESS: 'POST_REPORT_AGENCIES_SUCCESS',
  POST_REPORT_AGENCIES_FAILURE: 'POST_REPORT_AGENCIES_FAILURE',

};

export {
  authActions,
  jobActions,
  titleActions,
  openwebActions,
  dashboardActions,
  contactActions,
  companyActions,
  agencyActions,
}




// WEBPACK FOOTER //
// ./src/data/actionTypes.js